import t from '~t';
import React, { useCallback } from 'react';
import links from '~config/links';

import { Text, Label, Button, Icon } from '~ui';
import { Confirm } from '~co/overlay/dialog';

export default function BookmarkEditFormNote({
  autoFocus,
  item: { note },
  onCommit,
  onChange,
}) {
  const onChangeField = useCallback(
    (e) =>
      onChange({ [e.target.getAttribute('name')]: e.target.value }),
    [],
  );

  const onMarkdownClick = useCallback((e) => {
    e.preventDefault();
    Confirm(t.s('note'), {
      description: t.s('markdownSupported'),
      cancel: t.s('howToUse'),
    }).then((ok) => {
      if (!ok) window.open(links.help['add-note']);
    });
  }, []);

  return (
    <>
      <Label>{t.s('note')}</Label>
      <Text
        className='ui-edit-note'
        type='text'
        autoFocus={autoFocus == 'note'}
        name='note'
        value={note}
        autoSize={true}
        multiline={true}
        minRows={3}
        onChange={onChangeField}
        onBlur={onCommit}
      >
        <Button
          variant='ghost'
          size='icon'
          onClick={onMarkdownClick}
          tabIndex='-1'
          title={t.s('markdownSupported')}
        >
          <Icon name='markdown' />
        </Button>
      </Text>
    </>
  );
}
